/**
 * Centralized calculation utilities for decarbonization flow.
 *
 * This module provides standardized calculation functions that can be easily
 * configured for different regions and scenarios.
 */

// There is deliberately no client-side capital-cost helper: a category's
// capital total is the figure the backend computed and stored (it carries the
// regional multiplier and each catalog row's own inflation ratio). Read it with
// storedCategoryCapitalCost in ../utils.ts.

/**
 * Calculate energy demand (no x 1000 error!).
 * Energy is already in MWh/year in the database.
 *
 * @param energyUsePerYr - Energy use per year in MWh (from database)
 * @param count - Number of units
 * @returns Total energy demand in MWh/year
 */
export function calculateEnergyDemand(
  energyUsePerYr: number | string,
  count: number,
): number {
  const energy = Number(energyUsePerYr);

  // NO x 1000 here! Energy is already in MWh/year
  return energy * count;
}
